export let list = [
    {
        left: '/images/landing/landing-carinekanimba.png',

        right: '/images/landing/landing-davepeyton.png',
    },
    {
        left: '/images/landing/landing-palomamedina.png',

        right: `/images/landing/landing-duncancampbell.png`,
    },
    {
        left: '/images/landing/landing-rachelknox.png',

        right: '/images/landing/landing-jdhooge-r.png',
    },
    {
        left: '/images/landing/landing-tylermalek.png',

        right: '/images/landing/landing-karyyouman.png',
    }
]
